import RequestBase from './RequestBase';

export default class CompaniesSearchRequest extends RequestBase {
    constructor(searchTerm) {
        super();
        this._url = '/companies';
        this.method = 'GET';
        this.qs = {
            'searchTerm': searchTerm
        };
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Companies.js